// Broker facing copy for the DirectPath Processing selection (Commercial Broker channel only).
// Kept in one place because the same wording is used by the manual and XML upload workflows.
export const DIRECT_PATH_CONSTANTS = {
	ELIGIBLE_TAG: "DirectPath eligible",
	PROMPT_HEADER: "Would you like to use DirectPath Processing for this loan?",
	PROMPT_HELPER:
		"DirectPath streamlines setup and disclosure by routing this loan directly to the DirectPath Processing team. Applicable fees apply.",
	FEE_TEXT: "DirectPath Processing Fee: $795",
	YES_BUTTON: "Yes, use DirectPath",
	NO_BUTTON: "No, standard processing",
	LEARN_MORE: "Learn more about DirectPath",
	LEARN_MORE_URL: process.env.REACT_APP_DIRECT_PATH_LEARN_MORE_URL || "",
	POST_SELECTION_NOTICE:
		"Once this loan is submitted and a loan number is assigned, this selection cannot be changed in Logan Connect. To request a change, contact your DirectPath concierge.",
	MODAL_TITLE: "Before you begin — Processing Selection",
	MODAL_HELPER:
		"Select how you'd like this loan to be processed. This cannot be changed after the application is submitted.",
	MODAL_ELIGIBLE_SUFFIX: "is eligible for DirectPath Processing",
	DIRECT_PATH_OPTION_TITLE: "DirectPath Processing",
	DIRECT_PATH_OPTION_HELPER:
		"Routes this loan directly to the DirectPath team. Streamlines setup and disclosure for eligible programs.",
	STANDARD_OPTION_TITLE: "Standard Processing",
	STANDARD_OPTION_HELPER:
		"Follow the standard loan submission and processing workflow.",
	CONTINUE_BUTTON: "Continue to Application",
	CANCEL_BUTTON: "Cancel",
	STATUS_ON: "On",
	STATUS_OFF: "Off",
	STATUS_LOCKED: "Locked",
	BADGE_LABEL: "DirectPath",
	PROCESSING_LABEL: "Processing",
	ENCOMPASS_FIELD_ID:
		process.env.REACT_APP_DIRECT_PATH_FIELD_ID || "CX.CB.DPATH.YN",
	FIELD_VALUES: {
		YES: process.env.REACT_APP_DIRECT_PATH_YES_VALUE || "Y",
	},
	SELECTION_REQUIRED:
		"Select DirectPath or standard processing for this loan before continuing.",
};

export const DIRECT_PATH_OPTIONS = {
	DIRECT_PATH: "direct-path",
	STANDARD: "standard",
};

// Encompass may return Yes / Y / TRUE depending on field configuration.
export const isDirectPathYes = (value) => {
	if (value === true) return true;
	if (typeof value === "string") {
		const normalized = value.trim().toUpperCase();
		return normalized === "YES" || normalized === "Y" || normalized === "TRUE";
	}
	if (typeof value === "number") {
		return value === 1;
	}
	return false;
};

// Standard processing leaves the Encompass field unset, so only a Yes selection
// produces a field value.
export const buildDirectPathFieldValue = (directPath) => {
	if (directPath !== true) {
		return null;
	}
	return {
		id: DIRECT_PATH_CONSTANTS.ENCOMPASS_FIELD_ID,
		value: DIRECT_PATH_CONSTANTS.FIELD_VALUES.YES,
	};
};

// Only attach direct_path when a boolean selection exists so non-CB payloads stay unchanged.
export const withDirectPathPayload = (payload = {}, directPath) => {
	if (typeof directPath !== "boolean") {
		return payload;
	}
	return {
		...payload,
		direct_path: directPath,
	};
};
